import { collection, getDocs, doc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";

function slugify(name) {
  return name.toLowerCase().replace(/[^a-z0-9]/g, "");
}

export async function fetchHotelAmenities() {
  const snap = await getDocs(collection(db, "hotelAmenities"));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function addHotelAmenity(name, nameKa, icon) {
  const id = slugify(name);
  const data = { name, nameKa: nameKa || "", icon: icon || "check_circle", createdAt: new Date() };
  await setDoc(doc(db, "hotelAmenities", id), data);
  return { id, ...data };
}

export async function updateHotelAmenity(id, name, nameKa, icon) {
  await setDoc(
    doc(db, "hotelAmenities", id),
    { name, nameKa: nameKa || "", icon: icon || "check_circle" },
    { merge: true },
  );
}

export async function deleteHotelAmenity(id) {
  await deleteDoc(doc(db, "hotelAmenities", id));
}
